import React from 'react';
import './Footer.css';

const Footer = () => {
  const currentYear = new Date().getFullYear();

  // ✅ Social Links — Instagram active, baaki placeholders
  const socialLinks = [
    {
      name: 'Instagram',
      url: 'https://www.instagram.com/vktrend.online',
      active: true,
    },
    {
      name: 'Facebook',
      url: '#',   // TODO: Update later
      active: false,
    },
    {
      name: 'Twitter',
      url: '#',   // TODO: Update later
      active: false,
    },
    {
      name: 'Pinterest',
      url: '#',   // TODO: Update later
      active: false,
    },
  ];

  return (
    <footer className="fashion-footer">
      <div className="footer-container">

        {/* Brand Section */}
        <div className="footer-section brand">
          <a href="/" className="footer-logo">
            <span className="logo-text">
              VK<span className="logo-highlight">TREND</span>
            </span>
          </a>
          <p className="brand-description">
            Timeless fashion for the modern soul. Curated pieces that speak your style.
          </p>

          <div className="social-links">
            {socialLinks.map((social) => (
              <a
                key={social.name}
                href={social.url}
                target={social.active ? '_blank' : undefined}
                rel={social.active ? 'noopener noreferrer' : undefined}
                className={`social-link ${social.active ? 'active' : 'placeholder'}`}
                aria-label={social.name}
                onClick={(e) => {
                  if (!social.active) {
                    e.preventDefault();
                    alert(`${social.name} link coming soon!`);
                  }
                }}
              >
                {social.name === 'Instagram' && (
                  <svg viewBox="0 0 24 24" width="18" height="18">
                    <path d="M7.8 2h8.4C19.4 2 22 4.6 22 7.8v8.4c0 3.2-2.6 5.8-5.8 5.8H7.8C4.6 22 2 19.4 2 16.2V7.8C2 4.6 4.6 2 7.8 2zm-.2 2C5.5 4 4 5.5 4 7.6v8.8C4 18.5 5.5 20 7.6 20h8.8c2.1 0 3.6-1.5 3.6-3.6V7.6C20 5.5 18.5 4 16.4 4H7.6zm9.65 1.5a1.25 1.25 0 1 1 0 2.5 1.25 1.25 0 0 1 0-2.5zM12 7a5 5 0 1 1 0 10 5 5 0 0 1 0-10zm0 2a3 3 0 1 0 0 6 3 3 0 0 0 0-6z"/>
                  </svg>
                )}
                {social.name === 'Facebook' && (
                  <svg viewBox="0 0 24 24" width="18" height="18">
                    <path d="M22 12c0-5.52-4.48-10-10-10S2 6.48 2 12c0 4.84 3.44 8.87 8 9.8V15H8v-3h2V9.5C10 7.57 11.57 6 13.5 6H16v3h-2c-.55 0-1 .45-1 1v2h3v3h-3v6.8c4.56-.93 8-4.96 8-9.8z"/>
                  </svg>
                )}
                {social.name === 'Twitter' && (
                  <svg viewBox="0 0 24 24" width="18" height="18">
                    <path d="M22.46 6c-.77.35-1.6.58-2.46.69.88-.53 1.56-1.37 1.88-2.38-.83.5-1.75.85-2.72 1.05C18.37 4.5 17.26 4 16 4c-2.35 0-4.27 1.92-4.27 4.29 0 .34.04.67.11.98C8.28 9.09 5.11 7.38 3 4.79c-.37.63-.58 1.37-.58 2.15 0 1.49.75 2.81 1.91 3.56-.71 0-1.37-.2-1.95-.5v.03c0 2.08 1.48 3.82 3.44 4.21a4.22 4.22 0 0 1-1.93.07 4.28 4.28 0 0 0 4 2.98 8.52 8.52 0 0 1-5.33 1.84c-.34 0-.68-.02-1.02-.06C3.44 20.29 5.7 21 8.12 21 16 21 20.33 14.46 20.33 8.79c0-.19 0-.37-.01-.56.84-.6 1.56-1.36 2.14-2.23z"/>
                  </svg>
                )}
                {social.name === 'Pinterest' && (
                  <svg viewBox="0 0 24 24" width="18" height="18">
                    <path d="M12 2C6.48 2 2 6.48 2 12c0 4.84 3.44 8.87 8 9.8V17c0-1.1.9-2 2-2s2 .9 2 2v4.8c4.56-.93 8-4.96 8-9.8 0-5.52-4.48-10-10-10zm0 14c-2.21 0-4-1.79-4-4s1.79-4 4-4 4 1.79 4 4-1.79 4-4 4z"/>
                  </svg>
                )}
              </a>
            ))}
          </div>
        </div>

        {/* Quick Links */}
        <div className="footer-section">
          <h4 className="footer-title">Quick Links</h4>
          <ul className="footer-links">
            <li><a href="/">Home</a></li>
            <li><a href="/newarrivals">New Arrivals</a></li>
            
            <li><a href="/accessories">Accessories</a></li>
          </ul>
        </div>

        {/* Customer Service */}
        <div className="footer-section">
          <h4 className="footer-title">Customer Service</h4>
          <ul className="footer-links">
            <li><a href="/terms">Terms &amp; Conditions</a></li>
            <li><a href="/privacy">Privacy Policy</a></li>
            <li><a href="/shipping">Shipping Info</a></li>
            <li><a href="/returns">Returns &amp; Exchanges</a></li>
            <li><a href="/faq">FAQ</a></li>
          </ul>
        </div>

        {/* Newsletter */}
        <div className="footer-section newsletter">
          <h4 className="footer-title">Join the VK Family</h4>
          <p className="newsletter-text">
            Subscribe to get updates on new drops, exclusive offers, and style inspiration.
          </p>
          <form className="newsletter-form" onSubmit={(e) => e.preventDefault()}>
            <input
              type="email"
              placeholder="Your email address"
              className="newsletter-input"
              aria-label="Email for newsletter"
            />
            <button type="submit" className="newsletter-btn">Subscribe</button>
          </form>
        </div>
      </div>

      {/* Bottom Bar */}
      <div className="footer-bottom">
        <div className="footer-bottom-container">
          <p className="copyright">
            © {currentYear} VK TREND. All rights reserved.
          </p>
          <div className="payment-methods">
            <span className="payment-icon">💳</span>
            <span className="payment-icon">🅥</span>
            <span className="payment-icon">🅟</span>
            <span className="payment-icon">🄰</span>
            <span className="payment-icon">🄿</span>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;